/** Parse bot slug from hostname or ?slug= (local dev). */
export function slugFromLocation(
  hostname: string,
  search: string,
  baseDomain = 'bots.laivdata.com',
): string | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const q = params.get('slug')?.trim();
  if (q) return q;

  const host = hostname.toLowerCase().split(':')[0] ?? '';
  if (!host || host === baseDomain || host === 'localhost' || host === '127.0.0.1') {
    return null;
  }
  const suffix = `.${baseDomain}`;
  if (host.endsWith(suffix)) {
    const sub = host.slice(0, -suffix.length);
    // reject multi-level like a.b.bots...
    if (sub && !sub.includes('.')) return sub;
  }
  return null;
}
